// @flow
import itemsRemoved from 'app/common/redux/actions/feeds/itemsRemoved';
import ResourceFactory from 'app/common/lib/ResourceFactory';
import type { Thunk } from 'app/common/redux/types';
import { FEED_TYPE } from 'app/common/redux/reducers/feeds';

export type AggregatedCommentDeleted = {
  type: 'AGGREGATED_COMMENT_DELETED',
  payload: {
    parentId: string,
    aggregatedCommentId: string,
  },
};

export function aggregatedCommentDeleted(
  parentId: string,
  aggregatedCommentId: string,
): AggregatedCommentDeleted {
  return {
    type: 'AGGREGATED_COMMENT_DELETED',
    payload: {
      parentId,
      aggregatedCommentId,
    },
  };
}

export type AggregatedCommentDeleteData = {
  aggregatedCommentId: string,
  feedType?: 'aggregatedComments' | 'unifiedComments',
  parentId: string,
};

export function deleteAggregatedComment({
  aggregatedCommentId,
  feedType,
  parentId,
}: AggregatedCommentDeleteData): Thunk<void> {
  return (dispatch) => {
    ResourceFactory.create('AggregatedCommentResource', { commentId: aggregatedCommentId })
      .callDelete({ showError: false })
      .then((response: Object) => {
        dispatch(
          itemsRemoved({
            feedId: parentId,
            feedType: feedType || FEED_TYPE.AGGREGATED_COMMENTS,
            itemIds: [aggregatedCommentId],
            itemType: 'aggregatedcomment',
          }),
        );
        dispatch(aggregatedCommentDeleted(parentId, aggregatedCommentId));
        return response;
      });
  };
}
